import React from 'react';
import { Calendar, Gauge, Clock } from 'lucide-react';
import { KpiCard } from '../../societies/components/tabs/dashboard/KpiCard';
import type { SavVehicleProfile } from '../types/dashboard.types';

interface VehicleProfileCardsProps {
  profile: SavVehicleProfile;
}

export const VehicleProfileCards: React.FC<VehicleProfileCardsProps> = ({
  profile,
}) => {
  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
      <KpiCard
        title="Âge moyen du véhicule au moment de la panne"
        value={profile.avgVehicleAge > 0 ? `${profile.avgVehicleAge} ans` : '—'}
        icon={Calendar}
        color="orange"
      />
      <KpiCard
        title="Kilométrage moyen du véhicule au moment de la panne"
        value={
          profile.avgVehicleKm > 0
            ? new Intl.NumberFormat('fr-FR').format(profile.avgVehicleKm) + ' km'
            : '—'
        }
        icon={Gauge}
        color="orange"
      />
      <KpiCard
        title="Délai moyen d'apparition de la panne après la vente"
        value={profile.avgDelayMonths > 0 ? `${profile.avgDelayMonths} mois` : '—'}
        icon={Clock}
        color="orange"
      />
    </div>
  );
};
